module.exports = require('./helpers/bundle-url').getBundleURL('cqLDD') + "default.e12aade0.png";